import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import i18n from "../../../i18n";
import { map } from "lodash";
import { delEmployeesAdminDelete } from "../../../helpers/api_rombo_helper";
import SimpleAlertError from "../../../components/Alerts/SimpleAlertError";

const DeleteBulkModal = ({ isOpen, toggle, setDeleteBulkModal, setShowAlertSuccess, setTextHeader, setTextBody, checkDeleteEmployees, setCheckDeleteEmployees, setReloadEmployee, reloadEmployee, token, setClickDeleteEmployee }) => {

  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  function onClickSave() {
    let body = [];
    checkDeleteEmployees.map((checkDeleteEmployee, index) => {
      body.push({ id: checkDeleteEmployee.id, status: "DELETED" })
    })
    delEmployeesAdminDelete(token, { ids: body })
      .then((response) => {
        setDeleteBulkModal(false)
        setShowAlertSuccess(true)
        setClickDeleteEmployee(false)
        setReloadEmployee(!reloadEmployee)
        setCheckDeleteEmployees([])
        setCheckDeleteEmployees([])
        setTextHeader(i18n.t("DeletedEmployee"))
        setTextBody(i18n.t("SuccessDeletedEmployee"))
      })
      .catch((error) => {
        console.error("Error - delEmployeesAdminDeleteBulk -", error)
        setErrorAlertMessage((error.response?.data?.detail || error.message))
        setErrorAlert(true)
      })
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"lg"}
    >
      <div>
        <p className="cancellation-title">{i18n.t("DeleteEmployee")}</p>
        <div className="modal-separator" />
        <ModalBody className="mt-0 pt-0">
          <SimpleAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert} text={errorAlertMessage} />
          <div className="delete-modal-content">
            <p className="delete-modal-consequence">
              <i className="mdi mdi-information-outline" />
              {i18n.t("TextDeleteEmployee")}
            </p>
            <p className="delete-modal-bulk-count">
              {i18n.t("EmployeesToDelete")}: <strong>{checkDeleteEmployees.length}</strong>
            </p>
            <div className="delete-modal-employees-list">
              {map(checkDeleteEmployees, (checkDeleteEmployee, key) => (
                <div className="delete-modal-employee-card" key={key}>
                  <div className="delete-modal-employee-avatar">
                    <span className="delete-modal-employee-initials">
                      {checkDeleteEmployee.name ? checkDeleteEmployee.name.charAt(0).toUpperCase() : "U"}
                    </span>
                  </div>
                  <div className="delete-modal-employee-info">
                    <h4 className="delete-modal-employee-name">{checkDeleteEmployee.name}</h4>
                    <p className="delete-modal-employee-email">{checkDeleteEmployee.email}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-users border"
            type="button"
            onClick={onClickSave}
          >
            {i18n.t("Accept")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={() => {
              setCheckDeleteEmployees([])
              setDeleteBulkModal(false)
            }}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

DeleteBulkModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  setDeleteBulkModal: PropTypes.func,
  setShowAlertSuccess: PropTypes.func,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func,
  setClickDeleteEmployee: PropTypes.func,
  setCheckDeleteEmployees: PropTypes.func,
  setReloadEmployee: PropTypes.func,
  reloadEmployee: PropTypes.bool,
  token: PropTypes.object,
  checkDeleteEmployees: PropTypes.array
}

export default DeleteBulkModal;
